/**
 * GENERATED FILE — do not edit by hand.
 *
 * The Master List connection registry. Relationships are derived from the live schema
 * (lib/headlight_model/json/Headlight.json); scope + presentation come from Connection-Curation.js.
 * Regenerate:  node source/master-lists/build-connections.js
 */

module.exports = {
	"ASSOCIATIONS": {
		"OrganizationProject": {
			"JoinEntity": "ProjectOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			},
			"SideB": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			}
		},
		"ContactProject": {
			"JoinEntity": "ProjectContactJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Contact",
				"IDField": "IDContact",
				"DisplayField": "Title",
				"SearchFields": [
					"Title"
				],
				"TableColumns": [
					{
						"Key": "Title",
						"DisplayName": "Title"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			},
			"SideB": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			}
		},
		"FundingSourceProject": {
			"JoinEntity": "FundingSourceProjectJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "FundingSource",
				"IDField": "IDFundingSource",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			},
			"SideB": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			}
		},
		"ProjectReportNamedInstance": {
			"JoinEntity": "ReportNamedInstanceProjectJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			},
			"SideB": {
				"RecordSet": "ReportNamedInstance",
				"IDField": "IDReportNamedInstance",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDReportArchetype",
						"DisplayName": "IDReport Archetype"
					}
				]
			}
		},
		"LabProject": {
			"JoinEntity": "ProjectLabJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "Project",
				"IDField": "IDProject",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProjectType",
						"DisplayName": "IDProject Type"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			}
		},
		"ContactOrganization": {
			"JoinEntity": "ContactOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Contact",
				"IDField": "IDContact",
				"DisplayField": "Title",
				"SearchFields": [
					"Title"
				],
				"TableColumns": [
					{
						"Key": "Title",
						"DisplayName": "Title"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"EquipmentOrganization": {
			"JoinEntity": "EquipmentOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Equipment",
				"IDField": "IDEquipment",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Code",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Code",
						"DisplayName": "Code"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"BidItemOrganization": {
			"JoinEntity": "BidItemOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "BidItem",
				"IDField": "IDBidItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Units"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Units",
						"DisplayName": "Units"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					},
					{
						"Key": "IDProject",
						"DisplayName": "IDProject"
					},
					{
						"Key": "IDPayItem",
						"DisplayName": "IDPay Item"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"LineItemOrganization": {
			"JoinEntity": "LineItemOrganizationJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "LineItem",
				"IDField": "IDLineItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"ItemNumber"
				],
				"TableColumns": [
					{
						"Key": "ItemNumber",
						"DisplayName": "Item Number"
					},
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Quantity",
						"DisplayName": "Quantity"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"MaterialOrganization": {
			"JoinEntity": "OrganizationMaterialJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			},
			"SideB": {
				"RecordSet": "Organization",
				"IDField": "IDOrganization",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Type"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					}
				]
			}
		},
		"MaterialPayItem": {
			"JoinEntity": "MaterialPayItemJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			},
			"SideB": {
				"RecordSet": "PayItem",
				"IDField": "IDPayItem",
				"DisplayField": "Description",
				"SearchFields": [
					"Description",
					"ItemCode",
					"Name"
				],
				"TableColumns": [
					{
						"Key": "ItemCode",
						"DisplayName": "Item Code"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					},
					{
						"Key": "FunctionalClass",
						"DisplayName": "Functional Class"
					},
					{
						"Key": "Units",
						"DisplayName": "Units"
					},
					{
						"Key": "Amount",
						"DisplayName": "Amount"
					}
				]
			}
		},
		"MaterialMixSpecification": {
			"JoinEntity": "MixSpecificationMaterialJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			},
			"SideB": {
				"RecordSet": "MixSpecification",
				"IDField": "IDMixSpecification",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Code"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Code",
						"DisplayName": "Code"
					}
				]
			}
		},
		"LineItemMaterial": {
			"JoinEntity": "MaterialLineItemJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "LineItem",
				"IDField": "IDLineItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"ItemNumber"
				],
				"TableColumns": [
					{
						"Key": "ItemNumber",
						"DisplayName": "Item Number"
					},
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Quantity",
						"DisplayName": "Quantity"
					}
				]
			},
			"SideB": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			}
		},
		"MaterialTestSpecification": {
			"JoinEntity": "TestSpecificationMaterialJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Material",
				"IDField": "IDMaterial",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "MaterialCode",
						"DisplayName": "Material Code"
					},
					{
						"Key": "Type",
						"DisplayName": "Type"
					},
					{
						"Key": "CategoryName",
						"DisplayName": "Category"
					},
					{
						"Key": "UnitsImperial",
						"DisplayName": "Units"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestSpecification",
				"IDField": "IDTestSpecification",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Description"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					}
				]
			}
		},
		"PayItemTestSpecificationSet": {
			"JoinEntity": "PayItemTestSpecificationSetJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "PayItem",
				"IDField": "IDPayItem",
				"DisplayField": "Description",
				"SearchFields": [
					"Description",
					"ItemCode",
					"Name"
				],
				"TableColumns": [
					{
						"Key": "ItemCode",
						"DisplayName": "Item Code"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					},
					{
						"Key": "FunctionalClass",
						"DisplayName": "Functional Class"
					},
					{
						"Key": "Units",
						"DisplayName": "Units"
					},
					{
						"Key": "Amount",
						"DisplayName": "Amount"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestSpecificationSet",
				"IDField": "IDTestSpecificationSet",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Year"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Year",
						"DisplayName": "Year"
					}
				]
			}
		},
		"LabTestSpecificationSet": {
			"JoinEntity": "LabTestSpecificationSetJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestSpecificationSet",
				"IDField": "IDTestSpecificationSet",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Year"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Year",
						"DisplayName": "Year"
					}
				]
			}
		},
		"TestTestSpecificationSet": {
			"JoinEntity": "TestSpecificationSetTestJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Test",
				"IDField": "IDTest",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Description"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestSpecificationSet",
				"IDField": "IDTestSpecificationSet",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Year"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Year",
						"DisplayName": "Year"
					}
				]
			}
		},
		"LabTest": {
			"JoinEntity": "TestLabJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "Test",
				"IDField": "IDTest",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Description"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Description",
						"DisplayName": "Description"
					}
				]
			}
		},
		"LabSample": {
			"JoinEntity": "SampleLabJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "Sample",
				"IDField": "IDSample",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProject",
						"DisplayName": "IDProject"
					},
					{
						"Key": "IDMaterial",
						"DisplayName": "IDMaterial"
					},
					{
						"Key": "IDProductionPlant",
						"DisplayName": "IDProduction Plant"
					}
				]
			}
		},
		"LabTestInstance": {
			"JoinEntity": "TestInstanceLabJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Lab",
				"IDField": "IDLab",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDOrganization",
						"DisplayName": "IDOrganization"
					},
					{
						"Key": "IDOrganizationAddress",
						"DisplayName": "IDOrganization Address"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestInstance",
				"IDField": "IDTestInstance",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDTestPlan",
						"DisplayName": "IDTest Plan"
					},
					{
						"Key": "IDTest",
						"DisplayName": "IDTest"
					},
					{
						"Key": "IDLab",
						"DisplayName": "IDLab"
					}
				]
			}
		},
		"LineItemLot": {
			"JoinEntity": "LineItemLotJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "LineItem",
				"IDField": "IDLineItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"ItemNumber"
				],
				"TableColumns": [
					{
						"Key": "ItemNumber",
						"DisplayName": "Item Number"
					},
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Quantity",
						"DisplayName": "Quantity"
					}
				]
			},
			"SideB": {
				"RecordSet": "Lot",
				"IDField": "IDLot",
				"DisplayField": "Name",
				"SearchFields": [
					"Name"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "IDMixDesign",
						"DisplayName": "IDMix Design"
					},
					{
						"Key": "IDContract",
						"DisplayName": "IDContract"
					}
				]
			}
		},
		"LineItemSample": {
			"JoinEntity": "SampleLineItemJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "LineItem",
				"IDField": "IDLineItem",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"ItemNumber"
				],
				"TableColumns": [
					{
						"Key": "ItemNumber",
						"DisplayName": "Item Number"
					},
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Quantity",
						"DisplayName": "Quantity"
					}
				]
			},
			"SideB": {
				"RecordSet": "Sample",
				"IDField": "IDSample",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProject",
						"DisplayName": "IDProject"
					},
					{
						"Key": "IDMaterial",
						"DisplayName": "IDMaterial"
					},
					{
						"Key": "IDProductionPlant",
						"DisplayName": "IDProduction Plant"
					}
				]
			}
		},
		"SampleTestInstance": {
			"JoinEntity": "TestInstanceSampleJoin",
			"JoinURLPrefix": "/1.0/",
			"SideA": {
				"RecordSet": "Sample",
				"IDField": "IDSample",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDProject",
						"DisplayName": "IDProject"
					},
					{
						"Key": "IDMaterial",
						"DisplayName": "IDMaterial"
					},
					{
						"Key": "IDProductionPlant",
						"DisplayName": "IDProduction Plant"
					}
				]
			},
			"SideB": {
				"RecordSet": "TestInstance",
				"IDField": "IDTestInstance",
				"DisplayField": "Name",
				"SearchFields": [
					"Name",
					"Status"
				],
				"TableColumns": [
					{
						"Key": "Name",
						"DisplayName": "Name"
					},
					{
						"Key": "Status",
						"DisplayName": "Status"
					},
					{
						"Key": "IDTestPlan",
						"DisplayName": "IDTest Plan"
					},
					{
						"Key": "IDTest",
						"DisplayName": "IDTest"
					},
					{
						"Key": "IDLab",
						"DisplayName": "IDLab"
					}
				]
			}
		}
	},
	"EntityConnections": {
		"Project": {
			"ReadTabs": [
				{
					"Association": "OrganizationProject",
					"Title": "Organizations"
				},
				{
					"Association": "ContactProject",
					"Title": "Contacts"
				},
				{
					"Association": "FundingSourceProject",
					"Title": "Funding Sources"
				},
				{
					"Association": "ProjectReportNamedInstance",
					"Title": "Report Instances"
				},
				{
					"Association": "LabProject",
					"Title": "Labs"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "BidItem",
					"FilterField": "IDProject",
					"Title": "Bid Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDPayItem",
							"DisplayName": "IDPay Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDPayItem",
							"Entity": "PayItem",
							"DisplayField": "Name",
							"Label": "Pay Item"
						}
					]
				},
				{
					"RecordSet": "LineItem",
					"FilterField": "IDProject",
					"Title": "Line Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "ItemNumber",
							"DisplayName": "Item Number"
						},
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Quantity",
							"DisplayName": "Quantity"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDPayItem",
							"Entity": "PayItem",
							"DisplayField": "Name",
							"Label": "Pay Item"
						}
					]
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDProject",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						},
						{
							"Field": "IDProductionPlant",
							"Entity": "ProductionPlant",
							"DisplayField": "Name",
							"Label": "Production Plant"
						}
					]
				},
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDProject",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						},
						{
							"Field": "IDLab",
							"Entity": "Lab",
							"DisplayField": "Name",
							"Label": "Lab"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Contract": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Project",
					"FilterField": "IDContract",
					"Title": "Projects",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProjectType",
							"DisplayName": "IDProject Type"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProjectType",
							"Entity": "ProjectType",
							"DisplayField": "Name",
							"Label": "Project Type"
						},
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				},
				{
					"RecordSet": "BidItem",
					"FilterField": "IDContract",
					"Title": "Bid Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDPayItem",
							"DisplayName": "IDPay Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDPayItem",
							"Entity": "PayItem",
							"DisplayField": "Name",
							"Label": "Pay Item"
						}
					]
				},
				{
					"RecordSet": "LineItem",
					"FilterField": "IDContract",
					"Title": "Line Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "ItemNumber",
							"DisplayName": "Item Number"
						},
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Quantity",
							"DisplayName": "Quantity"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDPayItem",
							"Entity": "PayItem",
							"DisplayField": "Name",
							"Label": "Pay Item"
						}
					]
				},
				{
					"RecordSet": "Lot",
					"FilterField": "IDContract",
					"Title": "Lots",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDMixDesign",
							"DisplayName": "IDMix Design"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDMixDesign",
							"Entity": "MixDesign",
							"DisplayField": "Name",
							"Label": "Mix Design"
						}
					]
				},
				{
					"RecordSet": "Core",
					"FilterField": "IDContract",
					"Title": "Cores",
					"DisplayField": "IDCore",
					"Columns": [
						{
							"Key": "IDLot",
							"DisplayName": "IDLot"
						},
						{
							"Key": "IDSample",
							"DisplayName": "IDSample"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDLot",
							"Entity": "Lot",
							"DisplayField": "Name",
							"Label": "Lot"
						},
						{
							"Field": "IDSample",
							"Entity": "Sample",
							"DisplayField": "Name",
							"Label": "Sample"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"User": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Organization": {
			"ReadTabs": [
				{
					"Association": "OrganizationProject",
					"Title": "Projects"
				},
				{
					"Association": "ContactOrganization",
					"Title": "Contacts"
				},
				{
					"Association": "EquipmentOrganization",
					"Title": "Equipments"
				},
				{
					"Association": "BidItemOrganization",
					"Title": "Bid Items"
				},
				{
					"Association": "LineItemOrganization",
					"Title": "Line Items"
				},
				{
					"Association": "MaterialOrganization",
					"Title": "Materials"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "Project",
					"FilterField": "IDOrganization",
					"Title": "Projects",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProjectType",
							"DisplayName": "IDProject Type"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProjectType",
							"Entity": "ProjectType",
							"DisplayField": "Name",
							"Label": "Project Type"
						}
					]
				},
				{
					"RecordSet": "Contract",
					"FilterField": "IDOrganization",
					"Title": "Contracts",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDContractType",
							"DisplayName": "IDContract Type"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContractType",
							"Entity": "ContractType",
							"DisplayField": "Name",
							"Label": "Contract Type"
						}
					]
				},
				{
					"RecordSet": "Contact",
					"FilterField": "IDOrganization",
					"Title": "Contacts",
					"DisplayField": "Title",
					"Columns": [
						{
							"Key": "Title",
							"DisplayName": "Title"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": []
				},
				{
					"RecordSet": "ObservationTag",
					"FilterField": "IDOrganization",
					"Title": "Observation Tags",
					"DisplayField": "Description",
					"Columns": [
						{
							"Key": "Description",
							"DisplayName": "Description"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDBidItem",
							"DisplayName": "IDBid Item"
						},
						{
							"Key": "IDLineItem",
							"DisplayName": "IDLine Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDBidItem",
							"Entity": "BidItem",
							"DisplayField": "Name",
							"Label": "Bid Item"
						},
						{
							"Field": "IDLineItem",
							"Entity": "LineItem",
							"DisplayField": "Name",
							"Label": "Line Item"
						}
					]
				},
				{
					"RecordSet": "BidItem",
					"FilterField": "IDOrganization",
					"Title": "Bid Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDPayItem",
							"DisplayName": "IDPay Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						}
					]
				},
				{
					"RecordSet": "Lab",
					"FilterField": "IDOrganization",
					"Title": "Labs",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDOrganizationAddress",
							"DisplayName": "IDOrganization Address"
						}
					],
					"ChipFields": []
				},
				{
					"RecordSet": "MixDesign",
					"FilterField": "IDOrganization",
					"Title": "Mix Designs",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "MaterialCode",
							"DisplayName": "Material Code"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDMixType",
							"DisplayName": "IDMix Type"
						}
					],
					"ChipFields": [
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				},
				{
					"RecordSet": "Product",
					"FilterField": "IDOrganization",
					"Title": "Products",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "ProductCategory",
							"DisplayName": "Product Category"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				},
				{
					"RecordSet": "ProductionPlant",
					"FilterField": "IDOrganization",
					"Title": "Production Plants",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDOrganizationAddress",
							"DisplayName": "IDOrganization Address"
						}
					],
					"ChipFields": []
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDOrganization",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Role": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "User",
					"FilterField": "IDRole",
					"Title": "Users",
					"DisplayField": "NameLast",
					"Columns": [
						{
							"Key": "NameLast",
							"Keys": [
								"NameFirst",
								"NameLast"
							],
							"DisplayName": "Name"
						},
						{
							"Key": "Title",
							"DisplayName": "Title"
						},
						{
							"Key": "Email",
							"DisplayName": "Email"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProjectOffice",
							"Entity": "ProjectOffice",
							"DisplayField": "Name",
							"Label": "Project Office"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Material": {
			"ReadTabs": [
				{
					"Association": "MaterialPayItem",
					"Title": "Pay Items"
				},
				{
					"Association": "MaterialMixSpecification",
					"Title": "Mix Specifications"
				},
				{
					"Association": "LineItemMaterial",
					"Title": "Line Items"
				},
				{
					"Association": "MaterialOrganization",
					"Title": "Organizations"
				},
				{
					"Association": "MaterialTestSpecification",
					"Title": "Test Specifications"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "MixDesign",
					"FilterField": "IDMaterial",
					"Title": "Mix Designs",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "MaterialCode",
							"DisplayName": "Material Code"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDMixType",
							"DisplayName": "IDMix Type"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				},
				{
					"RecordSet": "Product",
					"FilterField": "IDMaterial",
					"Title": "Products",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "ProductCategory",
							"DisplayName": "Product Category"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDMaterial",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDProductionPlant",
							"Entity": "ProductionPlant",
							"DisplayField": "Name",
							"Label": "Production Plant"
						}
					]
				}
			],
			"MatrixAssociations": [
				{
					"Association": "MaterialPayItem",
					"Title": "Pay Items grid"
				}
			],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Product": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Sample",
					"FilterField": "IDProduct",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"MixDesign": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Lot",
					"FilterField": "IDMixDesign",
					"Title": "Lots",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDMixDesign",
							"DisplayName": "IDMix Design"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						}
					]
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDMixDesign",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"PayItem": {
			"ReadTabs": [
				{
					"Association": "PayItemTestSpecificationSet",
					"Title": "Specification Sets"
				},
				{
					"Association": "MaterialPayItem",
					"Title": "Materials"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "BidItem",
					"FilterField": "IDPayItem",
					"Title": "Bid Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDPayItem",
							"DisplayName": "IDPay Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						}
					]
				},
				{
					"RecordSet": "LineItem",
					"FilterField": "IDPayItem",
					"Title": "Line Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "ItemNumber",
							"DisplayName": "Item Number"
						},
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Quantity",
							"DisplayName": "Quantity"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						}
					]
				}
			],
			"MatrixAssociations": [
				{
					"Association": "MaterialPayItem",
					"Title": "Materials grid"
				}
			],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"TestSpecificationSet": {
			"ReadTabs": [
				{
					"Association": "PayItemTestSpecificationSet",
					"Title": "Pay Items"
				},
				{
					"Association": "LabTestSpecificationSet",
					"Title": "Labs"
				},
				{
					"Association": "TestTestSpecificationSet",
					"Title": "Tests"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "PayItem",
					"FilterField": "IDTestSpecificationSet",
					"Title": "Pay Items",
					"DisplayField": "Description",
					"Columns": [
						{
							"Key": "ItemCode",
							"DisplayName": "Item Code"
						},
						{
							"Key": "Description",
							"DisplayName": "Description"
						},
						{
							"Key": "FunctionalClass",
							"DisplayName": "Functional Class"
						},
						{
							"Key": "Units",
							"DisplayName": "Units"
						},
						{
							"Key": "Amount",
							"DisplayName": "Amount"
						}
					],
					"ChipFields": []
				},
				{
					"RecordSet": "TestSpecification",
					"FilterField": "IDTestSpecificationSet",
					"Title": "Test Specifications",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Description",
							"DisplayName": "Description"
						}
					],
					"ChipFields": []
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"TestSpecification": {
			"ReadTabs": [
				{
					"Association": "MaterialTestSpecification",
					"Title": "Materials"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "TestSpecificationRequirement",
					"FilterField": "IDTestSpecification",
					"Title": "Requirements",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDTestSpecification",
							"DisplayName": "IDTest Specification"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						}
					],
					"ChipFields": [
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"TestSpecificationRequirement": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Test": {
			"ReadTabs": [
				{
					"Association": "LabTest",
					"Title": "Labs"
				},
				{
					"Association": "TestTestSpecificationSet",
					"Title": "Specification Sets"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "TestSpecificationRequirement",
					"FilterField": "IDTest",
					"Title": "Requirements",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "IDTestSpecification",
							"DisplayName": "IDTest Specification"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						}
					],
					"ChipFields": [
						{
							"Field": "IDTestSpecification",
							"Entity": "TestSpecification",
							"DisplayField": "Name",
							"Label": "Test Specification"
						}
					]
				},
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDTest",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDLab",
							"Entity": "Lab",
							"DisplayField": "Name",
							"Label": "Lab"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Lab": {
			"ReadTabs": [
				{
					"Association": "LabTest",
					"Title": "Tests"
				},
				{
					"Association": "LabTestSpecificationSet",
					"Title": "Specification Sets"
				},
				{
					"Association": "LabProject",
					"Title": "Projects"
				},
				{
					"Association": "LabSample",
					"Title": "Samples"
				},
				{
					"Association": "LabTestInstance",
					"Title": "Test Instances"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDLab",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"LineItem": {
			"ReadTabs": [
				{
					"Association": "LineItemOrganization",
					"Title": "Organizations"
				},
				{
					"Association": "LineItemLot",
					"Title": "Lots"
				},
				{
					"Association": "LineItemMaterial",
					"Title": "Materials"
				},
				{
					"Association": "LineItemSample",
					"Title": "Samples"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "ObservationTag",
					"FilterField": "IDLineItem",
					"Title": "Observation Tags",
					"DisplayField": "Description",
					"Columns": [
						{
							"Key": "Description",
							"DisplayName": "Description"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDBidItem",
							"DisplayName": "IDBid Item"
						},
						{
							"Key": "IDLineItem",
							"DisplayName": "IDLine Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						},
						{
							"Field": "IDBidItem",
							"Entity": "BidItem",
							"DisplayField": "Name",
							"Label": "Bid Item"
						}
					]
				},
				{
					"RecordSet": "Sample",
					"FilterField": "IDLineItem",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				},
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDLineItem",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"BidItem": {
			"ReadTabs": [
				{
					"Association": "BidItemOrganization",
					"Title": "Organizations"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "ObservationTag",
					"FilterField": "IDBidItem",
					"Title": "Observation Tags",
					"DisplayField": "Description",
					"Columns": [
						{
							"Key": "Description",
							"DisplayName": "Description"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDBidItem",
							"DisplayName": "IDBid Item"
						},
						{
							"Key": "IDLineItem",
							"DisplayName": "IDLine Item"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						},
						{
							"Field": "IDLineItem",
							"Entity": "LineItem",
							"DisplayField": "Name",
							"Label": "Line Item"
						}
					]
				},
				{
					"RecordSet": "LineItem",
					"FilterField": "IDBidItem",
					"Title": "Line Items",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "ItemNumber",
							"DisplayName": "Item Number"
						},
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Quantity",
							"DisplayName": "Quantity"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						}
					]
				},
				{
					"RecordSet": "TestInstance",
					"FilterField": "IDBidItem",
					"Title": "Test Instances",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDTestPlan",
							"DisplayName": "IDTest Plan"
						},
						{
							"Key": "IDTest",
							"DisplayName": "IDTest"
						},
						{
							"Key": "IDLab",
							"DisplayName": "IDLab"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDTest",
							"Entity": "Test",
							"DisplayField": "Name",
							"Label": "Test"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ObservationManifest": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ProjectType": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Project",
					"FilterField": "IDProjectType",
					"Title": "Projects",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProjectType",
							"DisplayName": "IDProject Type"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ContractType": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Contract",
					"FilterField": "IDContractType",
					"Title": "Contracts",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDOrganization",
							"DisplayName": "IDOrganization"
						},
						{
							"Key": "IDContractType",
							"DisplayName": "IDContract Type"
						}
					],
					"ChipFields": [
						{
							"Field": "IDOrganization",
							"Entity": "Organization",
							"DisplayField": "Name",
							"Label": "Organization"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ObservationTag": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ReportNamedInstance": {
			"ReadTabs": [
				{
					"Association": "ProjectReportNamedInstance",
					"Title": "Projects"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ProductionPlant": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "Sample",
					"FilterField": "IDProductionPlant",
					"Title": "Samples",
					"DisplayField": "Name",
					"Columns": [
						{
							"Key": "Name",
							"DisplayName": "Name"
						},
						{
							"Key": "Status",
							"DisplayName": "Status"
						},
						{
							"Key": "IDProject",
							"DisplayName": "IDProject"
						},
						{
							"Key": "IDMaterial",
							"DisplayName": "IDMaterial"
						},
						{
							"Key": "IDProductionPlant",
							"DisplayName": "IDProduction Plant"
						}
					],
					"ChipFields": [
						{
							"Field": "IDProject",
							"Entity": "Project",
							"DisplayField": "Name",
							"Label": "Project"
						},
						{
							"Field": "IDMaterial",
							"Entity": "Material",
							"DisplayField": "Name",
							"Label": "Material"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Equipment": {
			"ReadTabs": [
				{
					"Association": "EquipmentOrganization",
					"Title": "Organizations"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Contact": {
			"ReadTabs": [
				{
					"Association": "ContactProject",
					"Title": "Projects"
				},
				{
					"Association": "ContactOrganization",
					"Title": "Organizations"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"CertificationType": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Account": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"FundingSource": {
			"ReadTabs": [
				{
					"Association": "FundingSourceProject",
					"Title": "Projects"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"MixSpecification": {
			"ReadTabs": [
				{
					"Association": "MaterialMixSpecification",
					"Title": "Materials"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Lot": {
			"ReadTabs": [
				{
					"Association": "LineItemLot",
					"Title": "Line Items"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "Core",
					"FilterField": "IDLot",
					"Title": "Cores",
					"DisplayField": "IDCore",
					"Columns": [
						{
							"Key": "IDLot",
							"DisplayName": "IDLot"
						},
						{
							"Key": "IDSample",
							"DisplayName": "IDSample"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDSample",
							"Entity": "Sample",
							"DisplayField": "Name",
							"Label": "Sample"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"ProjectOffice": {
			"ReadTabs": [],
			"ChildLists": [
				{
					"RecordSet": "User",
					"FilterField": "IDProjectOffice",
					"Title": "Users",
					"DisplayField": "NameLast",
					"Columns": [
						{
							"Key": "NameLast",
							"Keys": [
								"NameFirst",
								"NameLast"
							],
							"DisplayName": "Name"
						},
						{
							"Key": "Title",
							"DisplayName": "Title"
						},
						{
							"Key": "Email",
							"DisplayName": "Email"
						}
					],
					"ChipFields": []
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"TestInstance": {
			"ReadTabs": [
				{
					"Association": "SampleTestInstance",
					"Title": "Samples"
				},
				{
					"Association": "LabTestInstance",
					"Title": "Labs"
				}
			],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Sample": {
			"ReadTabs": [
				{
					"Association": "LineItemSample",
					"Title": "Line Items"
				},
				{
					"Association": "LabSample",
					"Title": "Labs"
				},
				{
					"Association": "SampleTestInstance",
					"Title": "Test Instances"
				}
			],
			"ChildLists": [
				{
					"RecordSet": "Core",
					"FilterField": "IDSample",
					"Title": "Cores",
					"DisplayField": "IDCore",
					"Columns": [
						{
							"Key": "IDLot",
							"DisplayName": "IDLot"
						},
						{
							"Key": "IDSample",
							"DisplayName": "IDSample"
						},
						{
							"Key": "IDContract",
							"DisplayName": "IDContract"
						}
					],
					"ChipFields": [
						{
							"Field": "IDContract",
							"Entity": "Contract",
							"DisplayField": "Name",
							"Label": "Contract"
						},
						{
							"Field": "IDLot",
							"Entity": "Lot",
							"DisplayField": "Name",
							"Label": "Lot"
						}
					]
				}
			],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		},
		"Core": {
			"ReadTabs": [],
			"ChildLists": [],
			"MatrixAssociations": [],
			"BulkAssociations": [],
			"UnlinkAssociations": []
		}
	}
};
